import React from "react";

export default function NoContentMessage({id, style, message="По вашему запросу ничего не найдено"}) {
    return <div id={id} style={style} className="no-content-msg">{message}</div>;
}